export default __webpack_public_path__ + "static/media/archive.d388741f.svg";